import Footer from "../../components/footer/footer"
import Header from "../../components/header/header"
import { customScript } from "../../common/customscript";
import { useEffect } from "react";
import DetailSection from "../../components/service_detail/servicedetail";
import SearchModel from "../../components/search_model/search";

const ServiceDetail = () => {
    useEffect(() => {
        customScript()
    },[])

    return (
        <>
            <Header />
            <DetailSection/>
            <Footer />
            <SearchModel/>
        </>
    )
}

export default ServiceDetail